import Fetch from '@/hooks/fetch';
import { pagingHookConfig } from '@/hooks/paging';
import actions from '../constants';

export default {
  useFetchSubscribers: ({ category, code, event }, readStatus, config = pagingHookConfig()) => Fetch.useFetchDispatch(
    actions.FETCH_SUBSCRIBERS,
    readStatus,
    { category, code, event },
    config,
  ),
};
